var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.size, 'size'],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }